import { Link, useOutletContext } from "react-router-dom";
import { useAuth } from "../../../auth/AuthProvider";
import { MdOutlineWavingHand } from "react-icons/md";
import {
  AccountData,
  GET_ACCOUNT_QUERY,
  PATCH_ACCOUNT_MUTATION,
} from "../../../api/Requests";
import { useMutation } from "@apollo/client";
import { myToastSave } from "../../../util/myToast";
import { useState } from "react";
import { RenderEditItem } from "../../../components/Preview/Edit/RenderEdits";

import styles from "./Dashboard.module.css";

export default function Dashboard() {
  const { session } = useAuth();
  const accountData = useOutletContext<AccountData>();
  const [accountUpdate] = useMutation<AccountData>(PATCH_ACCOUNT_MUTATION);
  const [fullName, setFullName] = useState(
    accountData?.account?.fullName || "",
  );

  function saveAccountInfo(dataName: string, dataValue: string) {
    const saveResponse = accountUpdate({
      variables: {
        input: {
          [dataName]: dataValue,
        },
      },
      update: (cache, { data }) => {
        if (data) {
          cache.writeQuery({
            query: GET_ACCOUNT_QUERY,
            data: data,
          });
        }
      },
    });
    myToastSave(saveResponse, "Saving...", "Account has been updated.");
  }
  return (
    <div>
      <div className={styles.dashboardContainer}>
        <div className={styles.dashboardContent}>
          {accountData?.account?.fullName ? (
            <>
              <h2>
                <MdOutlineWavingHand /> Hey {accountData?.account?.fullName}!
              </h2>
              <p>
                If you are looking for a place to start? Import your{" "}
                <Link to="/info">Information</Link>.
              </p>
              <p>
                This info will be used to craft a professional looking landing
                page.
              </p>
              <br />
              <h3>Quick Access</h3>
              <p>
                <Link to="/webpage#top">Edit Your Webpage</Link>
              </p>
              <p>
                <Link to="/settings">Publish Your Webpage</Link>
              </p>
            </>
          ) : (
            <>
              <h2>
                <MdOutlineWavingHand /> Welcome!
              </h2>
              <p>Looks like this is your first time here.</p>
              <p>
                Get started by entering your name:{" "}
                <b>
                  <RenderEditItem
                    inputItem={{
                      value: fullName,
                      setter: setFullName,
                    }}
                    placeholder="Full Name"
                  />
                </b>
              </p>

              {fullName && (
                <button
                  className="mainButton"
                  onClick={() => saveAccountInfo("fullName", fullName)}
                >
                  Save
                </button>
              )}
            </>
          )}
        </div>
      </div>
      <div className={styles.dashboardEmail}>
        {session?.user?.email && (
          <p>
            <b>Account Email:</b> {session.user.email}
          </p>
        )}
      </div>
    </div>
  );
}
